import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  bannerContainerStyle,
  bannerIconWrapperStyle,
  textContainerStyle
} from './styles.ts';

import { RocketShape } from '@/components/common/svg/shapes/RocketShape.tsx';
import { useBoostCountdown } from '@/hooks/useBoostCountdown';

const ICON_SIZE = 38;
const GAP = 1;
const RING_WIDTH = 2;
const RING_SIZE = ICON_SIZE + GAP * 2 + RING_WIDTH * 2;

export const BoostsBanner: FC = () => {
  const { t } = useTranslation();
  const { formatted, isActive, progress } = useBoostCountdown();

  return (
    <div style={containerStyle}>
      <div style={flexContainerStyle}>
        {isActive ? (
          <div style={progressRingStyle(progress)}>
            <div style={ringGapStyle}>
              <div style={iconWrapperStyle(true)}>
                <RocketShape width={20} height={20} fillColor="#fff" />
              </div>
            </div>
          </div>
        ) : (
          <div style={iconWrapperStyle(false)}>
            <RocketShape width={20} height={20} fillColor="#fff" />
          </div>
        )}
        <div style={textContainerStyle}>
          <p style={titleStyle}>{t('boosts_menu_item')}</p>
          <span style={subtitleStyle}>
            {isActive ? formatted : `${t('balance')}: 0`}
          </span>
        </div>
      </div>
    </div>
  );
};

const containerStyle: CSSProperties = {
  ...bannerContainerStyle,
  backgroundColor: '#FFF',
  width: '168px',
  height: '67px'
};

const flexContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center'
};

const progressRingStyle = (progress: number): CSSProperties => ({
  width: `${RING_SIZE}px`,
  height: `${RING_SIZE}px`,
  borderRadius: '50%',
  background: `conic-gradient(from 0deg, #EE0064 ${progress * 360}deg, rgba(238, 0, 100, 0.3) ${progress * 360}deg)`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0
});

const ringGapStyle: CSSProperties = {
  width: `${ICON_SIZE + GAP * 2}px`,
  height: `${ICON_SIZE + GAP * 2}px`,
  borderRadius: '50%',
  background: '#FFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const iconWrapperStyle = (isActiveBoost: boolean): CSSProperties => ({
  ...bannerIconWrapperStyle,
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  background: isActiveBoost ? '#EE0064' : '#000000'
});

const titleStyle: CSSProperties = {
  margin: 0,
  fontWeight: 'bold',
  fontSize: '14px'
};

const subtitleStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 400,
  color: '#000000'
};